import React from 'react';
import {Tile} from "../../Components/Tile/Tile";

interface DashboardTileProps {
    description: string;
    label: string;
    to?: string;
    iconName: string;
}

export const DashboardTile: React.FC<DashboardTileProps> = ({
                                  description,
                                  label,
                                  to,
                                  iconName,
                              }) => {
    return <>
        <Tile to={to} label={label} iconName={iconName} isClickable={false}>
            <p>{description}</p>
        </Tile>
    </>;
};
